import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router"
import { Observable, of } from "rxjs"
import { PreviewService } from "../../services/preview.service"

@Injectable()
export class ResourcePreviewGuard {
    constructor(public previewService: PreviewService) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        this.previewService.previewOnResource = true
        return of(true)
    }

    canDeactivate(
        component: any,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.previewService.previewOnResource = false

        return of(true)
    }
}
